import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import globeIcon from "../assets/globeIcon.svg"
import file from "../assets/fileIcon.svg"
import linkedin from "../assets/accountIcon.svg"
import noPhoto from "../assets/no-photo.png";

import { ToggleButton, Button } from "@mui/material";
import ButtonMailto from "./ButtonMailto";


import {
  getDatabase,
  ref,
  onValue,
  push,
  get,
  remove,
  update,
} from "firebase/database";
import firebase from "../firebase";

const Profile = () => {
  const [firedata, setFiredata] = useState();
  const { personalID } = useParams();

  useEffect(() => {
    const database = getDatabase(firebase);
    const userRef = ref(database, `/${personalID}`);
    get(userRef)
      .then((data) => {
        const mydata = data.val();

        setFiredata(mydata);
      })
      .catch((error) => { });

    // Calling the db for existing guests right away
    // const userId2 = personalID;
    // const childRef = ref(database, `/${userId2}/attendees`);

    // onValue(childRef, (response) => {
    //   const emptyArray = [];
    //   const data = response.val();
    //   for (let key in data) {
    //     // pushing the values from the object into our emptryArray
    //     emptyArray.push({ personalID: key, name: data[key] });
    //   }
    //   setGuestList(emptyArray);
    // });

    // Calling the description right away

    // const userId2 = personalID;
    // const childRef2 = ref(database, `/${personalID}/description`);
    // onValue(childRef2, (response) => {
    //   // const emptyArray = [];
    //   const data = response.val();
    //   setDescription(data);
    // });
  }, []);
  console.log(firedata);
  // const userSkills = firedata.skills

  const buttonSX = {
    backgroundColor: "#3834DC",
    textTransform: "none",
    borderRadius: "10px",
    fontWeight: "600",
    fontSize: "1.1rem",
    "&:hover": {
      backgroundColor: "#131087",
    },
  };


  return (

    <div className="wrapper">
      <>

              {firedata ? (
      <section className="profileContainer">

        {/* <p>{firedata.mentorType}</p> */}
        {/* <p>{firedata.name.firstName}</p> */}
        {/* <p>{`${firedata.name.firstName} ${firedata.data.name.lastName}`}</p> */}

        {/* <p>{firedata.skills.pmSkills}</p> */}
        {/* <p>{firedata.skills.designSkills}</p> */}
        {/* <Link to="/results">Results</Link> */}
        <div className="profileTop">
          <div className="profileImageContainer">
                {firedata.image[0].data_url ? (<img src={firedata.image[0].data_url} alt="placeholder" />) : <img src={noPhoto} alt="placeholder" /> }
            {/* <img src={firedata.image[0].data_url} alt="placeholder" /> */}
             {/* <img src={noPhoto} alt="" /> */}
          </div>
          <div className="profileInfo">
            <h2>{firedata.name.first} {firedata.name.last}</h2>
            <p>{firedata.pronouns}</p>
            {/* Add flag emoji/image for flag span */}
            {/* NEED TO RETHINK THIS PART */}
            <p className="location">{firedata.country}</p>
          </div>
          <div className="professionText">
            {firedata.company ? (
              <p>{firedata.expertise} at {firedata.company}</p>
              ) : null }
              <p>{firedata.expertise}: {firedata.expLevel} | {firedata.personality}</p>
          </div>
          <div className="formDetails">
            <h4>Mentor services:</h4>
            <p>{firedata.expLevel}, {firedata.goals}</p>
          </div>
        </div>

        {/* ABOUT SECTION */}
        <div className="about">
          <h4>About</h4>
          <p className="aboutInfo">{firedata.bio}</p>
        </div>
        
        {/* SKILLS SECTION */}
        <section className="profileSkills">
          <div className="expertise">
            <h4>Expertise</h4>
            <ul>
            { 
            // const userSkills = [{firedata.skills}]
              // const userSkillButton = 
              firedata.skills.map((skill, index) => (
                <li key={index} className="profileSkills">{skill}</li>

              ))}
            </ul>
          </div>

          <div className="language">
            <h4>Language(s)</h4>
            {/* <ToggleButton className="toggles" value={"English"}> */}
              <p className="language">English</p>
            {/* </ToggleButton> */}
          </div>

          <div className="timezone">
            <h4>Time zone</h4>
            {/* <ToggleButton className="toggles" value={"Eastern"}> */}
              <p className="timezone">{firedata.timeZone}</p>
            {/* </ToggleButton> */}
          </div>

          <div className="contact">
            <h4>Email address:</h4>
            <p>{firedata.email}</p>
            {/* add event handler for onClick */}
            {/* <a href={"mailto:{firedata.email}"}>{firedata.email}</a> */}
            {/* <ButtonMailto label={firedata.email} mailto="mailto:`${firedata.email}`" /> */}
          </div>

        </section>
        
        <Link to="/matches">
          <Button
            sx={buttonSX}
            className="button"
            variant="contained">
            Return to matches
          </Button>
        </Link>

      </section>
            )
              : null
            }
          </>
    </div>
  );
};

export default Profile;
